<template>
  <RangePicker
    type="games-learning"
    :title="$t('calculators_common.number_of_games')"
    :description="$t('calculators_common.select_number_of_games')"
  />
  <OptionPicker

  />
  <!-- default-selected="self_play" -->
  <!-- :disabled-options="['play_offline', 'stream']" -->
</template>
<script setup>
import RangePicker from "../commonpickers/RangePicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import { onMounted, computed, watch } from "vue";
const {
  setDetails,
  setPlatform,
  setGameAndPack,
  clearCheckout,
  setCalculating,
  getPackOptions,
  removePackOption,
  setPackOptions,
} = useCheckoutStore();

const { getGame, getGamePack } = useGameStore();

const duoQOption = computed(() => {
  const option = getGamePack?.pack_options?.find(
    (option) => option.const_title === "self_play"
  );
  if (option) {
    return option;
  }
  return null;
});

const isOptionSelected = (packOption) => {
  const selectedOption = getPackOptions.find((option) => option === packOption);
  if (!selectedOption) {
    return false;
  }
  return true;
};

const selectOption = (option) => {
  removePackOption({
    optionIds: option?.rules?.disable || [],
  });
  setPackOptions({
    options: [option.id],
  });
};

const handleDetails = () => {
  clearCheckout();

  // if (duoQOption.value) {
  //   selectOption(duoQOption.value);
  // }

  setDetails({
    numberOfGames: 1,
  });

  setPlatform({
    platform: 1,
  });

  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  setCalculating();
});
watch(duoQOption, (newVal) => {
  if (newVal.id) {
    selectOption(newVal);
  }
});
</script>
